import React from "react";
import { Box, Typography } from "@mui/material";
import { Target } from "lucide-react";
import { containerStyle, iconStyle, textStyle } from "./styles";

interface AssessmentStreakBadgeProps {
  streakCount: number;
}

export const AssessmentStreakBadge = ({
  streakCount,
}: AssessmentStreakBadgeProps) => {
  if (!Number.isFinite(streakCount) || streakCount <= 0) {
    return null;
  }

  const label =
    streakCount === 1
      ? "Streak: 1 correct"
      : `Streak: ${streakCount} correct`;

  return (
    <Box sx={containerStyle}>
      <Box sx={iconStyle}>
        <Target size={16} />
      </Box>
      <Typography sx={textStyle}>
        {label} <span aria-hidden="true">🔥</span>
      </Typography>
    </Box>
  );
};

export default AssessmentStreakBadge;
